import * as Yup from 'yup';

export const advancedFiltersValidations = Yup.object().shape({
	aspectRatio: Yup.string().required('Select an aspect ratio'),
	prompt: Yup.string().required('Prompt is required in this mode'),
});
